module.exports = __webpack_public_path__ + "img/small-coupon-icon.a7b1766.png";